import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-me-treinos',
  templateUrl: './me-treinos.component.html',
  styleUrls: ['./me-treinos.component.css']
})
export class MeTreinosComponent implements OnInit {
  existeTreino: boolean = false;
  hideCL: boolean = false;
  arrTreinos: any[] = [];
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    //this.hideCL = true;
    //this.existeTreino = true;
    this.carregarTreinos();
  }

  goFichaTreino(idTreino: any) :void{
    this.router.navigate(['me/fichatreino/' + idTreino]);
  }


  carregarTreinos() :void{
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.listarTreinos(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.arrTreinos = qRes['arrTreinos'];
        if(this.arrTreinos.length > 0){
          this.existeTreino = true;
        }
        else{
          this.existeTreino = false;
        }
      }
    })
  }

  goPesquisar(){
    this.router.navigate(['/pesquisando/profissionais']);
    
  }
}
